import api from '@pray/shared/utils/api';

export async function unschedulePrayRadioDaily({
  artistId,
  dailySeriesId,
  dailyItemId,
}: {
  artistId: string;
  dailySeriesId: string;
  dailyItemId: string;
}) {
  if (!artistId) throw Error('Artist ID is required');
  if (!dailySeriesId) throw Error('Daily Series ID is required');
  if (!dailyItemId) throw Error('Daily Item ID is required');

  const url = `/web/studio/artists/${artistId}/daily-series/${dailySeriesId}/daily-items/${dailyItemId}/pray-radio-schedule`;
  const response = await api.executeDeleteRequest(url);

  return response.data;
}
